import React, { memo } from "react";
import {
	BaseFieldProps,
	FieldEditorOptions,
	HasItems,
	ListField,
	identityRecordOfFieldEditorOptions
} from "@ploy-ui/form-fields";
import { FieldProps } from "formik";

interface ListFieldLiteralProps<T>
	extends FieldProps,
		Pick<BaseFieldProps, "suffix">,
		HasItems<T> {}

function ListFieldLiteralInternal<T extends any>(
	props: ListFieldLiteralProps<T>
) {
	return <ListField {...props} literal={true} />;
}

ListFieldLiteralInternal.displayName = "DployListFieldLiteral";
export const ListFieldLiteral = memo(ListFieldLiteralInternal);

const literalListFieldEditorProps: FieldEditorOptions["editableOptions"] = {
	suffix: true
};
export const EditorListFieldLiterals = identityRecordOfFieldEditorOptions({
	ListFieldLiteral: {
		editableOptions: literalListFieldEditorProps
	}
});
